import { addModulePrefix as p } from "../helpers"

// Signal actions for Sagas (do not change the store)
export const LOAD_CALENDAR = p(`LOAD_CALENDAR`)
export const INIT_CALENDAR = p(`INIT_CALENDAR`)

// Actions for reducer (change store)
export const LOAD_CALENDAR_STARTED = p(`LOAD_CALENDAR_STARTED`)
export const LOAD_CALENDAR_COMPLETED = p(`LOAD_CALENDAR_COMPLETED`)
export const LOAD_CALENDAR_FAILED = p(`LOAD_CALENDAR_FAILED`)

export const INIT_CALENDAR_STARTED = p(`INIT_CALENDAR_STARTED`)
export const INIT_CALENDAR_COMPLETED = p(`INIT_CALENDAR_COMPLETED`)
export const INIT_CALENDAR_FAILED = p(`INIT_CALENDAR_FAILED`)

export const ADD_EVENT = p(`ADD_EVENT`)
export const UPDATE_EVENT = p(`UPDATE_EVENT`)
export const REMOVE_EVENT = p(`REMOVE_EVENT`)
